import script from "./FinanceAnalytics.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinanceAnalytics.vue?vue&type=script&setup=true&lang=ts"

import "./FinanceAnalytics.vue?vue&type=style&index=0&id=33122334&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33122334"]])

export default __exports__